import { render, staticRenderFns } from "./BookmakerStacker.vue?vue&type=template&id=610cec7b"
import script from "./BookmakerStacker.vue?vue&type=script&lang=js"
export * from "./BookmakerStacker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports